module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('button', {
    staticClass: "modal-close is-large",
    staticStyle: {
      "z-index": "999"
    },
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43dd76c7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/_modal.vue
// module id = 1189
// module chunks = 0